import clsx from 'clsx'
import Link from 'next/link'
import { HTMLAttributes, ReactNode } from 'react'

import { Button } from '@/shared/ui'

import cl from './hint.module.scss'

type HintAction = {
	actionLabel?: string
	actionOnClick?: () => void
	actionHref?: string
}

interface HintProps extends HTMLAttributes<HTMLDivElement>, HintAction {
	theme?: 'light' | 'grey'
	variant?: 'row' | 'column'
	hint?: ReactNode
}

export const Hint = (props: HintProps) => {
	const {
		hint,
		theme = 'grey',
		variant = 'row',
		actionLabel = 'Узнать подробнее',
		actionHref,
		actionOnClick,
		className,
		...rest
	} = props

	return (
		<div className={clsx(cl.root, cl[theme], cl[variant], className)} {...rest}>
			<p>{hint}</p>
			{(actionHref || actionOnClick) && (
				<div className={cl.buttonContainer}>
					{actionOnClick ? (
						<Button className={cl.button} onClick={actionOnClick}>
							{actionLabel}
						</Button>
					) : (
						actionHref && (
							<Link prefetch={false} href={actionHref} target="_blank" className={cl.button}>
								{actionLabel}
							</Link>
						)
					)}
				</div>
			)}
		</div>
	)
}
